module.exports = __webpack_public_path__ + "static/media/smart-card@3x.822517c5.png";